import moment from "moment";
import { axios } from "../../../../lib/axios";

export const updateAppointmentRequest = (payload) => {
    return axios.put("appointment", { ...payload, isFromWeb: true, active: true })
}

export const getAppointments = ({practitionerId, status}) => {
    return axios.get(`appointment?practitionerId=${practitionerId}&status=${status}`);
};
export const createEncounter = ({ patient, practitioner, appointmentId, appointmentTime, orgId, questionnaireInfo, statusHistory, patientLocation, orgName}) => {
    const payload = {
        subject: patient,
        status: "in-progress",
        period: {
            start: appointmentTime
        },
        patientLocation: (patientLocation) ? patientLocation : questionnaireInfo?.location,
        participant: [
            {
                individual: practitioner,
                period: {
                    start: moment().utc().format()
                }
            }
        ],
        type: "encounter",
        appointmentId,
        managingOrganization: {
            reference: `Organization/${orgId}`,
            type: "Organization",
            display: orgName
        },
        intakeQuestions: questionnaireInfo,
        statusHistory: statusHistory,
        serviceProvider: {
            type: "Organization",
            reference: `Organization/${orgId}`,
            display: orgName
        }
    }
    return axios.post("encounter", payload)
}

export const searchEncounters = ({orgId, start, end, type, status, encounterId, practitionerId, page, pageSize, getAll = false, activePractitioner}) =>{
    // minimum url
    let url = `encounter/search?orgId=${orgId}`;
    url += (start) ? `&DateStart=${start}`:"";
    url += (end) ? `&DateEnd=${end}`:"";
    url += (type) ? `&type=${type}`:"";
    url += (encounterId) ? `&encounterId=${encounterId}`:"";
    url += (status) ? `&status=${status}`:"";
    url += (practitionerId) ? `&practitionerID=${practitionerId}`:"";
    url += (page) ? `&page=${page}`:"";
    url += (pageSize) ? `&pageSize=${pageSize}`:"";
    url += (getAll) ? `&getAll=${getAll}`:"";
    url += (activePractitioner) ? `&activePractitioner=${activePractitioner}`:"";
    return axios.get(url);
}

export const createEncounterInbound = ({ patient, status, practitionerId, practitionerName, proceedWith, orgId, orgName, questionnairInfo, requestedPeriod, statusHistory, patientLocation, serviceLineId, serviceLine }) => {
    let payload = {
        "subject": patient,
        "managingOrganization": {
            "reference": `Organization/${orgId}`,
            "type": "Organization",
            "display": orgName || '',
        },
        "serviceProvider": {
            display: orgName,
            type: "Organization",
            reference: `Organization/${orgId}`
        },
        "practitionerId": practitionerId,
        "participant": [
            {
                "individual": {
                    "reference": `Practitioner/${practitionerId}`,
                    "type": "Practitioner",
                    "display": practitionerName
                }
            }
        ],
        "period": requestedPeriod,
        // removing because we will use this type for encounter Billing
        // "type": [
        //     {
        //         "coding": [
        //             {
        //                 "code": "VV",
        //                 "display": "Virtual Visit Encounter Type"
        //             }
        //         ]
        //     }
        // ],
      //  "questionnaireResponse": questionnairInfo,
        "patientLocation": (patientLocation) ? patientLocation : questionnairInfo?.location,
        "intakeQuestions": questionnairInfo,
        "proceedWith": proceedWith,
        "status" : status,
        "statusHistory": statusHistory
    }
    if (serviceLineId) {
        payload.serviceLineId = serviceLineId
    }
    if (serviceLine) {
        payload.serviceLine = serviceLine
    }
    return axios.post("encounter", payload)
}

export const editEncounter = ({encounterId, status, encounterClass, patient, practitionerId, practitionerName, proceedWith, orgId, orgName, questionnairInfo, requestedPeriod, patientLocation, statusHistory, actor, participant, serviceLineId, serviceLine}) => {    
    const defaultParticipant = [
        {
            "individual": {
                "reference": `Practitioner/${practitionerId}`,
                "type": "Practitioner",
                "display": practitionerName
            }
        }
    ];

    const participantArray = participant ? participant : defaultParticipant;

    let payload = {};
    payload.participant = participantArray;
    if(patient) payload.subject = patient;
    if(orgId && orgName) payload.serviceProvider = {
        reference: `Organization/${orgId}`,
        type: "Organization",
        display: orgName
    };
    if(practitionerId) payload.practitionerId = practitionerId;
    if(requestedPeriod) payload.requestedPeriod = requestedPeriod;
    if(questionnairInfo) payload.intakeQuestions = questionnairInfo;
    if(proceedWith) payload.proceedWith = proceedWith;
    if(status) payload.status = status;
    if(patientLocation) payload.patientLocation = patientLocation;
    if(statusHistory) payload.statusHistory = statusHistory;
    if(actor) payload.actor = actor;
    if(encounterClass) payload.class = encounterClass;
    if(serviceLineId) payload.serviceLineId = serviceLineId;
    if(serviceLine) payload.serviceLine = serviceLine;

    // const payload = {
    //     "subject": patient,
    //     "serviceProvider": {
    //         reference: `Organization/${orgId}`,
    //         type: "Organization",
    //         display: orgName
    //     },
    //     "practitionerId": practitionerId,
    //     "participant": participantArray,
    //     "requestedPeriod": requestedPeriod,
    //     // removing because we will use this type for encounter Billing
    //     // "type": [
    //     //     {
    //     //         "coding": [
    //     //             {
    //     //                 "code": "VV",
    //     //                 "display": "Virtual Visit Encounter Type"
    //     //             }
    //     //         ]
    //     //     }
    //     // ],
    //  //   "questionnaireResponse": questionnairInfo, 
    //     "intakeQuestions": questionnairInfo,
    //     "proceedWith": proceedWith,
    //     "status" : status,
    //     "patientLocation": (patientLocation) ? patientLocation : questionnairInfo?.location,
    //     "statusHistory": statusHistory,
    //     "actor": actor,
    //     "class": encounterClass ? encounterClass : "",
    //     "serviceLineId": serviceLineId,
    //     "serviceLine": serviceLine
    // }
    return axios.put(`encounter/${encounterId}`, payload)
}

/**
 * Get the active practitioners for the current encounter.  This uses 
 * the encounterObj participant array and finds practitioners in that list, and only
 * practitioners with the period.end set to null.
 * If a practitioner id is provided it checks to see if that ONE practitioner
 * is active.
 * @param {Object} currentEncounter - The current encounter object.
 * @param {string} practitionerId - The practitioner ID to filter by.
 * @returns {Array} - The active practitioners.
 */
export const getActivePractitioners = (encounterObj, practitionerId = null) => {
    if(practitionerId) {
        return encounterObj?.participant?.filter(participant => participant?.individual?.type === "Practitioner" 
          && participant?.period?.end === null 
          && participant?.individual?.reference === `Practitioner/${practitionerId}`) || [];
      }
      return encounterObj?.participant?.filter(participant => participant?.individual?.type === "Practitioner" 
        && participant?.period?.end === null) || [];
}

export const editEncounterIntakeQuestions = ({encounterId, payload}) => {
    payload.inPlaceUpdate = true;    
    return axios.put(`encounter/${encounterId}`, payload)
}

export const addAddendumToEncounter = ({encounterId, addenda}) => {
    return axios.put(`encounter/${encounterId}`, {note: addenda})
}

export const triggerReportDelivery = ({encounterId}) => {
    return axios.post(`/report-delivery/trigger?encounterId=${encounterId}`)
}

export const bookAppointment = ({serviceCategory, requestType, slot, practitionerId, patientId, requestedPeriod, description, comment, sessionToken, isReschedule = false, document = null, intakeQuestions, patientLocation, scheduleId, newEncounterIdFromModal, orgId }) => {
    const payload = {
        requestType: (requestType) ? requestType : practitionerId ? "provider" : "organization",
        status: "proposed",
        description,
        practitionerId,
        comment,
        patientId,
        requestedPeriod,
        document: null,
        isFromWeb: true,
        sessionToken,
        isReschedule,
        intakeQuestions,
        patientLocation,
        scheduleId,
        slot,
        serviceCategory,
        active: true,
        newEncounterId: newEncounterIdFromModal ? newEncounterIdFromModal : null,
        ...(orgId ? { orgId } : {})
    }
    return axios.post("appointment", payload)
}

export const rescheduleAppointment = ({ serviceCategory, keepOldSlot, intakeQuestions, slot, appointmentId, requestedPeriod, practitionerId, scheduleId, description, orgId }) => {
    const payload = {
        appointmentId,
        requestedPeriod,
        practitionerId,
        description,
        requestor: `Practitioner/${practitionerId}`,
        scheduleId,
        slot,
        keepOldSlot,
        serviceCategory,
        intakeQuestions,
        active: true,
        ...(orgId ? { orgId } : {})
    }
    return axios.post("appointment/reschedule", payload)
}
export const checkSchedule = ({ actorId, date, orgId, endDate }) => {
    const resolvedEndDate = endDate ? endDate : (date ? moment.utc(date).add(1,'M').format('YYYY-MM-DD') : null)
    return axios.get(`schedule/check?actorId=${actorId}&date=${date}${orgId ? `&orgId=${orgId}`:``}${resolvedEndDate ? `&endDate=${resolvedEndDate}`:""}`)
}
export const getlistPractitioners = ({ orgId, scopeOfPractice }) => {
    const scopeParam = scopeOfPractice ? `&scopeOfPractice=${encodeURIComponent(scopeOfPractice)}` : "";
    return axios.get(`practitioner/authorized?orgId=${orgId}${scopeParam}`)
}
export const getSlots = ({ actorId, date, serviceCategoryId, orgId, scopeOfPractice  }) => {
    return axios.get(`schedule/patient?actorId=${actorId}&date=${date}&serviceCategoryId=${serviceCategoryId}${orgId ? `&orgId=${orgId}`:``}${scopeOfPractice ? `&scopeOfPractice=${scopeOfPractice}`:``}`)
}


export const getEncounterRecord = ({ encounterId }) => {
    return axios.get(`encounter/${encounterId}`)
};
export const getQueueRecord = ({encounterId, userOrganizationId}) => {
    return axios.get(`queue/${encounterId}?orgId=${userOrganizationId}`)
};
export const getEncounterQuestionnaireResponses = ({encounterId}) => {
    return axios.get(`/questionnaireresponse?encounterId=${encounterId}`)
};

export const getPractitionerDataForQueue = ({practitionerId}) => {
    return axios.get(`/practitioner/${practitionerId}`)
};

export const getAppointmentRecord = ({appointmentId}) => {
    return axios.get(`/appointment/${appointmentId}`)
}
